
import React, { useEffect, useRef } from "react";
import {
  Route,
  Router,
  Switch,
} from "react-router-dom";

import { MakeMakeLiveEmbed, ReadingPlansEmbed } from './reading-resources/embed';
import { StateProvider } from './components/Store.js';
import { AppHistory } from './browser-history.js';

/**
 * Bootstrap liviano para rutas embebibles.
 *
 * A diferencia de `ApplicationBootstrap`, esta rama evita montar la app completa
 * y sus wrappers globales: PWA, validacion de sesion, manejo de conexion,
 * header, footer, notificaciones, popups y UI de actualizacion.
 *
 * Solo conserva `Router` y `StateProvider`, que son necesarios para las rutas
 * embed y para que los componentes puedan leer idioma/traducciones desde el store.
 */
export const EmbedApplicationBootstrap = () => {
	const embedContentRef = useRef(null);

	useEffect(() => {
		const postEmbedHeight = () => {
			const content = embedContentRef.current;
			const height = Math.ceil(
				Math.max(
					content?.scrollHeight || 0,
					content?.getBoundingClientRect().height || 0,
					document.body?.scrollHeight || 0,
					document.documentElement?.scrollHeight || 0,
				)
			);

			window.parent.postMessage(
				{
					type: 'makemake:embed:height',
					height,
					path: window.location.pathname,
				},
				'*'
			);
		};

		const schedulePostEmbedHeight = () => {
			window.requestAnimationFrame(postEmbedHeight);
		};

		schedulePostEmbedHeight();
		window.addEventListener('resize', schedulePostEmbedHeight);
		window.addEventListener('load', schedulePostEmbedHeight);

		const resizeObserver = window.ResizeObserver && embedContentRef.current
			? new ResizeObserver(schedulePostEmbedHeight)
			: null;

		if (resizeObserver) {
			resizeObserver.observe(embedContentRef.current);
		}

		return () => {
			window.removeEventListener('resize', schedulePostEmbedHeight);
			window.removeEventListener('load', schedulePostEmbedHeight);
			if (resizeObserver) {
				resizeObserver.disconnect();
			}
		};
	}, []);

	return (
		<Router history={AppHistory}>
			<StateProvider>
				<main
					ref={embedContentRef}
					role="main"
					id="main"
					className="reading-resources embed-reading-resources"
				>
					<Switch>
						<Route exact path="/embed/:language/comunidad/reading-plans" component={ReadingPlansEmbed} />
						<Route exact path="/embed/:language/comunidad/makemake-live" component={MakeMakeLiveEmbed} />
					</Switch>
				</main>
			</StateProvider>
		</Router>
	);
}